const TSFAlgolia = (() => {


  const APP_ID = '5ZNV4MTXTO';
  const API_KEY = '6bdc8cf52bce82ef8c26aa06c14d74b2';
  const INDEX = "shopifyaus_products";
  const SEARCHES_INDEX = "shopifyaus_products_query_suggestions";
  const COLLECTIONS_INDEX = "shopifyaus_collections";

  var isMobile = null;
  var dropdownOpen = false;
  var trendingSearches = [];
  var defaultDropdown = null;
  var defaultDropdownMobile = null;

  const escapeHtml = (unsafe) => {
    if (!unsafe) return '';
    return unsafe
      .toString()
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  const storeLiquidTemplate = () => {
    defaultDropdown = document.getElementById('search-dropdown').innerHTML;
    defaultDropdownMobile = document.getElementById('mobile-search-dropdown').innerHTML;
  }

  const queryApi = async (index, params = {}) => {
    const url = `https://${APP_ID}-dsn.algolia.net/1/indexes/${index}/query`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'X-Algolia-API-Key': API_KEY,
        'X-Algolia-Application-Id': APP_ID,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });
    return res.json();
  };

  const multiQuery = async (index, params = {}) => {
    const url = `https://${APP_ID}-dsn.algolia.net/1/indexes/*/queries`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'X-Algolia-API-Key': API_KEY,
        'X-Algolia-Application-Id': APP_ID,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });
    return res.json();
  };

  const getPresentmentPrice = async (handle) => {
    const url = `/products/${handle}.js`;
    const res = await fetch(url, {
      method: 'GET'
    });
    const data = await res.json();

    const price_max = data.price_max;
    const price_min = data.price_min;

    const priceElement = document.querySelector(`.dropdown-price[data-handle="${handle}"]`);


    if (!priceElement) return;
    const moneyFormat = `{{ amount }}`;
    if (price_min < price_max){
        priceElement.innerHTML = `${window.currencySymbol}${window.Shopify.formatMoney(data.price_min, moneyFormat)} - ${window.currencySymbol}${window.Shopify.formatMoney(data.price_max, moneyFormat)}`;
    }
    else {
      priceElement.innerHTML = `${window.currencySymbol}${window.Shopify.formatMoney(data.price, moneyFormat)}`;
    }

    

    priceElement.classList.add('visible');
    const price = data.price;
  }

  const searchAlgolia = async (query) => {
    const params = {
    "query": query,
    "hitsPerPage": isMobile ? 12 : 4
    }
    const json = await queryApi(INDEX, params);
    if (json.hits.length > 0){
      renderResults(json.hits, json.nbHits ?? 0);
    }
    
    customResultsOverride(query);
  };

//todo cache result
  const getTrendingSearches = async () => {
    if (trendingSearches.length === 0){
      const params = {
      "query": "",
      "hitsPerPage": 5
      }
      const json = await queryApi(SEARCHES_INDEX, params);


      const newSearches = [];
      for (let i=0; i<json.hits.length; i++){
        const query = json.hits[i].query;
        newSearches.push(query);
      }

      TSFAlgolia.trendingSearches = newSearches;
    }
    else {
      return trendingSearches;
    }
  };

  //fetch collection results and query suggestions in a multi
    const getSuggestions = async (query) => {

      const params = {
      "requests": [
        {
          "indexName": SEARCHES_INDEX,
          "params": `query=${query}&hitsPerPage=5`
        },
        {
          "indexName": COLLECTIONS_INDEX,
          "params": `query=${query}&hitsPerPage=4`
        }
      ]
    }
      const json = await multiQuery(SEARCHES_INDEX, params);

      renderQuerySuggestions(json?.results[0]?.hits);
      renderCollections(json?.results[1]?.hits);

  };

  const customResultsOverride = (query) => {
    if (!query){
      return;
    }
    const overrides = [
      {
        keyword: "return",
        title: "TSF RETURNS",
        buttonText: "Visit Returns Portal",
        buttonURL: "/pages/returns",
        image: "https://thatssofetch.com.au/cdn/shop/t/286/assets/general-img_200x.PNG?v=124578632051170011351772067624"
      }
    ]

    let override = null;
    for (let i=0; i<overrides.length; i++){
      if (query.includes(overrides[i].keyword)){
        override = overrides[i];
      }
    }

    let CONTAINER_SELECTOR = "search-dropdown-trending";
    let TITLE_SELECTOR = "custom-results-title";
    let IMAGE_SELECTOR = "custom-results-image";
    let BUTTON_SELECTOR = "custom-results-button";

     if (isMobile){
        CONTAINER_SELECTOR = "mobile-search-dropdown-trending";
        TITLE_SELECTOR = "m-custom-results-title";
        IMAGE_SELECTOR = "m-custom-results-image";
        BUTTON_SELECTOR = "m-custom-results-button";
    }


      const container = document.getElementById(CONTAINER_SELECTOR);
      const title = document.getElementById(TITLE_SELECTOR);
      const image = document.getElementById(IMAGE_SELECTOR);
      const button = document.getElementById(BUTTON_SELECTOR);


    if (override){
      title.innerHTML = override.title;
      image.innerHTML = `<img src="${override.image}">`;
      button.innerHTML = override.buttonText;
      button.setAttribute('href', override.buttonURL);
      container.classList.add('custom');
    }
    else {
      container.classList.remove('custom');
    }
  }

  const renderResults = (results, nbHits) => {

      let RESULTS_SELECTOR = "search-dropdown-results";
      let FULL_RESULTS_BUTTON = "more-results-button";
      let FOOTER_SELECTOR = "more-results-footer";

      if (isMobile){
        RESULTS_SELECTOR = "search-dropdown-results-mobile";
        FULL_RESULTS_BUTTON = "more-results-button-mobile";
        FOOTER_SELECTOR = "more-results-footer-mobile";
      }

      

      const container = document.getElementById(RESULTS_SELECTOR);
      const footer = document.getElementById(FOOTER_SELECTOR);
      const fullResults = document.getElementsByClassName(FULL_RESULTS_BUTTON);


      const html = results.map(product => `<a aria-label="Featured product - ${escapeHtml(product.title)}" href="/products/${encodeURIComponent(product.handle)}">
                <img alt="" class="dropdown-image" src="${escapeHtml(product.image)}&width=300">
                <p>${escapeHtml(product.title)}</p>
                <p><b class="dropdown-price" data-handle="${escapeHtml(product.handle)}"></b></p>
            </a>`).join('');

      container.innerHTML = html;

      footer.classList.add('visible');
      if (nbHits > 4){
        for (let i=0; i<fullResults.length; i++){
          const button = fullResults[i];
          button.innerHTML = `See full results (${nbHits})`;
          button.classList.remove('hidden');
        }

      }
      else {
         for (let i=0; i<fullResults.length; i++){
          const button = fullResults[i];
          button.classList.add('hidden');
        }
        
      }
     

      results.forEach((result)=>{
        getPresentmentPrice(result.handle);
      })
      
  }

  const renderCollections = (hits) => {

     hits = (hits || []).filter(t => !t.title.includes(','));

    if (!hits || hits.length == 0){
      return;
    }

      let COLLECTIONS_SELECTOR = "dropdown-collections";
      let COLLECTIONS_TITLE = "dropdown-collections-title";
      if (isMobile){
        COLLECTIONS_SELECTOR = "dropdown-collections-mobile";
        COLLECTIONS_TITLE = "m-dropdown-collections-title";
      }

      const container = document.getElementById(COLLECTIONS_SELECTOR);
      const title = document.getElementById(COLLECTIONS_TITLE);

      const html = hits.map(term => `<a href="/collections/${encodeURIComponent(term.handle)}">${escapeHtml(term.title)}</a>`).join('');
      container.innerHTML = html;
      title.textContent = "COLLECTIONS";

  }

  const renderQuerySuggestions = (hits) => {

      if (!hits || hits.length == 0){
        return;
      }

      let TRENDING_SELECTOR = isMobile ? "dropdown-trending-searches-mobile" : "dropdown-trending-searches";
      let TRENDING_TITLE = isMobile ? "m-dropdown-trending-title" : "dropdown-trending-title";
      
      const container = document.getElementById(TRENDING_SELECTOR);
      const title = document.getElementById(TRENDING_TITLE);

      const html = hits.map(term => `<a href="/search?q=${encodeURIComponent(term.query)}">${escapeHtml(term.query)}</a>`).join('');
      container.innerHTML = html;
       title.textContent = "SUGGESTED";
  }

  const renderTrendingSearches = () => {


    if (TSFAlgolia.trendingSearches.length > 0){

      let TRENDING_SELECTOR = "dropdown-trending-searches";

      if (isMobile){
        TRENDING_SELECTOR = "dropdown-trending-searches-mobile";
      }


      const container = document.getElementById(TRENDING_SELECTOR);


      const html = TSFAlgolia.trendingSearches.map(term => `<a href="/search?q=${encodeURIComponent(term)}">${escapeHtml(term)}</a>`).join('');
      container.innerHTML = html;

    }
  }

  const connectFrontEnd = () => {

    isMobile = window.matchMedia("(max-width: 768px)").matches;

    //desktop
    const DROPDOWN_SELECTOR = "search-dropdown";
    const FORM_SELECTOR = "search-bar-form";
    const CONTENT_SELECTOR = "search-dropdown-content";
    const TRENDING_SELECTOR = "search-dropdown-trending";
    const SEARCHBAR_SELECTOR = "search-bar-input";
    const SEARCHBAR_CONTAINER_SELECTOR = "search-bar-desktop";
    const OVERLAY_SELECTOR = "search-bar-overlay";
    const FULL_RESULTS_BUTTON = "more-results-button";
    const CLEAR_BUTTON = "clear-button";

    const searchField = document.getElementById(SEARCHBAR_SELECTOR);
    const searchBar = document.getElementById(SEARCHBAR_CONTAINER_SELECTOR);
    const overlay = document.getElementById(OVERLAY_SELECTOR);
    const dropdown = document.getElementById(DROPDOWN_SELECTOR);
    const clearButton = document.getElementById(CLEAR_BUTTON);
    const fullResults = document.getElementById(FULL_RESULTS_BUTTON);
    const form = document.getElementById(FORM_SELECTOR);

    //mobile
    const MOBILE_BUTTON_SELECTOR = "mobile-search-button";
    const MOBILE_SEARCH_BAR = "search-bar-mobile";
    const MOBILE_FORM_SELECTOR = "search-bar-form";
    const MOBILE_DROPDOWN = "mobile-search-dropdown";
    const MOBILE_CLOSE_BUTTON = "close-search-button";
    const MOBILE_SEARCHBAR_SELECTOR = "search-bar-input-mobile";
    const CLEAR_BUTTON_MOBILE = "clear-button-mobile";
    const MOBILE_MENU_SEARCH = "search-icon-mobile-menu";
    const FLOATING_NAV_SEARCH = "floating-nav-search";
    

    const mobileSearch = document.getElementById(MOBILE_BUTTON_SELECTOR);
    const floatingNavSearch = document.getElementById(FLOATING_NAV_SEARCH);
    const mobileSearchBar = document.getElementById(MOBILE_SEARCH_BAR);
    const mobileDropdown = document.getElementById(MOBILE_DROPDOWN);
    const mobileCloseSearch = document.getElementById(MOBILE_CLOSE_BUTTON);
    const mobileSearchField = document.getElementById(MOBILE_SEARCHBAR_SELECTOR);
    const mobileClearButton = document.getElementById(CLEAR_BUTTON_MOBILE);
    const mobileMenuSearch = document.getElementById(MOBILE_MENU_SEARCH);


    searchField?.addEventListener('input', (e) => {
      const query = e.target.value;
      if (query && query.length > 2){
        searchAlgolia(query);
        getSuggestions(query);
      }
      else if (!query && defaultDropdown){
        document.getElementById('search-dropdown').innerHTML = defaultDropdown;
        TSFAlgolia.renderTrendingSearches();
      }

    })

    mobileSearchField?.addEventListener('input', (e) => {
      const query = e.target.value;
      
      if (query) {
        mobileClearButton?.classList.add('visible');
      } else {
        mobileClearButton?.classList.remove('visible');
      }
      
      if (query && query.length > 2){
        searchAlgolia(query);
        getSuggestions(query);
      }
      else if (!query && defaultDropdownMobile){
        document.getElementById('mobile-search-dropdown').innerHTML = defaultDropdownMobile;
        TSFAlgolia.renderTrendingSearches();
      }
    })


    mobileSearch?.addEventListener('click',async  (e) => {

        mobileSearchBar.style.display = 'flex';

        setTimeout(()=>{
          mobileSearchBar.classList.add('open');
        },50);

        mobileSearchField.focus({ preventScroll: true });

        setTimeout(() => {
          mobileDropdown.classList.add('open');
        }, 200);
        setTimeout(() => {
          mobileDropdown.classList.add('expanded');
        }, 225);

        setTimeout(()=>{
          mobileSearchField.style.caretColor = 'hotpink';
        },600);
        
        TSFAlgolia.renderTrendingSearches();

        dropdownOpen = true;

        try {
          posthog.capture('mobile_search_bar_clicked');  
        }
        catch(e){}
        

        
    })

      floatingNavSearch?.addEventListener('click',async  (e) => {

        mobileSearchBar.style.display = 'flex';

        setTimeout(()=>{
          mobileSearchBar.classList.add('open');
        },50);

        mobileSearchField.focus({ preventScroll: true });

        setTimeout(() => {
          mobileDropdown.classList.add('open');
        }, 200);
        setTimeout(() => {
          mobileDropdown.classList.add('expanded');
        }, 225);

        setTimeout(()=>{
          mobileSearchField.style.caretColor = 'hotpink';
        },600);
        
        TSFAlgolia.renderTrendingSearches();

        dropdownOpen = true;

        try {
          posthog.capture('mobile_search_bar_clicked');  
        }
        catch(e){}
        
    })

    mobileMenuSearch?.addEventListener('click',async  (e) => {
          mobileSearchBar.style.display = 'flex';

          setTimeout(()=>{
            mobileSearchBar.classList.add('open');
          },50);

          mobileSearchField.focus({ preventScroll: true });

          setTimeout(() => {
            mobileDropdown.classList.add('open');
          }, 200);
          setTimeout(() => {
            mobileDropdown.classList.add('expanded');
          }, 225);

          setTimeout(()=>{
            mobileSearchField.style.caretColor = 'hotpink';
          },600);
          
          TSFAlgolia.renderTrendingSearches();

          dropdownOpen = true;

          try {
          posthog.capture('mobile_search_bar_clicked');  
          }
          catch(e){}
    });

    mobileCloseSearch?.addEventListener('click', ()=> {
       mobileSearchField.value = "";
       mobileClearButton?.classList.remove('visible');
       mobileSearchBar.classList.remove('open');
       mobileDropdown.classList.remove('expanded');
       mobileDropdown.classList.remove('open');
       mobileSearchField.style.caretColor = 'transparent';
       dropdownOpen = false;
    })


    searchBar?.addEventListener('click', async ()=> {
        if (!dropdownOpen){
            document.querySelector(".site-header")?.classList.add("searchOpen");
            searchBar.classList.add('maximized');
            overlay.classList.add('visible');
            dropdown.classList.add('open');
            searchField.focus();
            setTimeout(() => {
                dropdown.classList.add('expanded');
            }, 50);
            
            TSFAlgolia.renderTrendingSearches();
            
            dropdownOpen = true;
            try {
              posthog.capture('desktop_search_button_clicked');  
            }
            catch(e){}
            }
    });

    overlay?.addEventListener('click', () => {
        dropdown.classList.remove('expanded');
        searchField.value = "";
        document.querySelector(".site-header")?.classList.remove("searchOpen");
        setTimeout(() => {
            searchBar.classList.remove('maximized');
            overlay.classList.remove('visible');
            dropdown.classList.remove('open');
            dropdownOpen = false;
        }, 300);
    });

    clearButton?.addEventListener('click', ()=> {
      searchField.value = "";
      searchField.focus();
    })

    mobileClearButton?.addEventListener('click', ()=> {
      mobileSearchField.value = "";
      mobileClearButton?.classList.remove('visible');
      mobileSearchField.focus();

      mobileSearchField.dispatchEvent(new Event('input'));
    })


    window.addEventListener('resize', () => {

      isMobile = window.matchMedia("(max-width: 768px)").matches;
      
      if (dropdownOpen) {
        // Close mobile search
        if (mobileSearchBar?.classList.contains('open')) {
          mobileSearchField.value = "";
          mobileClearButton?.classList.remove('visible');
          mobileSearchBar.classList.remove('open');
          mobileDropdown.classList.remove('expanded');
          mobileDropdown.classList.remove('open');
        }
        
        // Close desktop search
        if (dropdown?.classList.contains('open')) {
          dropdown.classList.remove('expanded');
          searchField.value = "";
          document.querySelector(".site-header")?.classList.remove("searchOpen");
          searchBar.classList.remove('maximized');
          overlay.classList.remove('visible');
          dropdown.classList.remove('open');
        }
        
        dropdownOpen = false;
      }
    });

  }

  



  return {
    getTrendingSearches,
    connectFrontEnd,
    trendingSearches,
    renderTrendingSearches,
    storeLiquidTemplate
  };
})();

document.addEventListener("DOMContentLoaded", ()=> {
    TSFAlgolia.storeLiquidTemplate(); //liquid cant be rerendered later
    TSFAlgolia.connectFrontEnd();
    TSFAlgolia.getTrendingSearches();
})


